export default __webpack_public_path__ + "static/media/kse.04cb153b.png";